module.exports = __webpack_public_path__ + "img/zhonggu3.4ceee184.jpg";